import { AfterViewInit, Component, ElementRef, OnDestroy, signal, viewChild, inject, computed, Signal, Inject, PLATFORM_ID } from '@angular/core';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { ResolutionService } from '../resolution.service';
import { SignalsStoreService } from '../signals-store.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-shop-slider-banner',
  imports: [],
  templateUrl: './shop-slider-banner.component.html',
  styleUrl: './shop-slider-banner.component.scss'
})
export class ShopSliderBannerComponent implements OnDestroy, AfterViewInit {

  //#region Services

  #resolutionService = inject(ResolutionService);
  #signalsStoreService = inject(SignalsStoreService);

  //#endregion

  //#region Properties

  shopSlider = viewChild.required<ElementRef>('shopSlider');

  slides = signal<{ title: string; boldSubtitle: string; subtitle: string }[]>([
    {
      title: 'REGENERATIVE',
      boldSubtitle: '& SUSTAINABLE',
      subtitle: '',
    },
    {
      title: 'FARM FRESH',
      boldSubtitle: '',
      subtitle: 'Fruits & Vegetables',
    },
    {
      title: 'EAT HEALTY',
      boldSubtitle: '',
      subtitle: 'Be Healthy',
    },
    {
      title: 'REGENERATIVE',
      boldSubtitle: '& SUSTAINABLE',
      subtitle: '',
    },
  ]);

  isMobile = computed(() => this.#resolutionService.isMobile());

  isSmallMobile = computed(() => this.#resolutionService.isSmallMobile());

  slider: KeenSliderInstance | any = null;

  dotHelper = signal<number[]>([]);

  currentSlide = 0;

  isShopBannerHidden = computed(() => this.#signalsStoreService.isShopBannerHidden());

  hasSession = computed(() => this.#signalsStoreService.hasSession());

  isSessionLoaded = computed(() => this.#signalsStoreService.isSessionLoaded());

  //#endregion

  //#region Constructors

  constructor(@Inject(PLATFORM_ID) private platformId: any) { }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.#setUpDefaultSlider();
      }, 500);
    }
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }

  //#endregion

  //#region Methods

  #setUpDefaultSlider() {

    if (!(this.shopSlider()?.nativeElement)) return;
    this.slider = new KeenSlider(this.shopSlider().nativeElement, {
      initial: this.currentSlide,
      renderMode: 'performance',
      loop: this.slides().length > 1,
      drag: false,
      slideChanged: s => this.currentSlide = s.track.details.rel
    }, [
      (slider) => {
        let timeout: NodeJS.Timeout | null = null;
        let mouseOver = false
        function clearNextTimeout() {
          if (timeout)
            clearTimeout(timeout);
        }
        function nextTimeout() {

          if (timeout)
            clearTimeout(timeout);

          if (mouseOver) return
          timeout = setTimeout(() => {
            slider.next()
          }, 1000 * 5)
        }
        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
          })
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
          })
          nextTimeout()
        })
        slider.on("dragStarted", clearNextTimeout)
        slider.on("animationEnded", nextTimeout)
        slider.on("updated", nextTimeout)
      }
    ]);

    if (this.slider.track?.details?.slides?.length) {
      this.dotHelper.set([
        ...Array(this.slider.track.details.slides.length)
      ]);
    }
  }

  // #getSlides() {

  //   const version = 4; // Importat to change this version number when updating the images
  //   this.slides.set([
  //     {
  //       title: '<p class="m-0 text-white">Fresh & Healthy.</p>',
  //       text: `<p class="m-0">Wholesome Organic Food</p>`,
  //       img: computed(() => {
  //         // const tablet = this.isMobile();
  //         // const mobile = this.isSmallMobile();
  //         // const folder = mobile ? 'Mobile' : tablet ? 'Tablet' : 'Desktop';
  //         // return `/assets/images/shop-slider/${folder}/1.png?v=${version}`
  //         return `/assets/images/landing/home/carousel/1.webp?v=${version}`
  //       })
  //     },
  //     {
  //       title: '<p class="m-0 text-white">Fresh & Healthy.</p>',
  //       text: `<p class="m-0">Wholesome Organic Food</p>`,
  //       img: computed(() => {
  //         // const tablet = this.isMobile();
  //         // const mobile = this.isSmallMobile();
  //         // const folder = mobile ? 'Mobile' : tablet ? 'Tablet' : 'Desktop';
  //         // return `/assets/images/shop-slider/${folder}/1.png?v=${version}`
  //         return `/assets/images/landing/home/carousel/2.webp?v=${version}`
  //       })
  //     },
  //     {
  //       title: '<p class="m-0 text-white">Fresh & Healthy.</p>',
  //       text: `<p class="m-0">Wholesome Organic Food</p>`,
  //       img: computed(() => {
  //         // const tablet = this.isMobile();
  //         // const mobile = this.isSmallMobile();
  //         // const folder = mobile ? 'Mobile' : tablet ? 'Tablet' : 'Desktop';
  //         // return `/assets/images/shop-slider/${folder}/1.png?v=${version}`
  //         return `/assets/images/landing/home/carousel/3.webp?v=${version}`
  //       })
  //     },
  //     {
  //       title: '<p class="m-0 text-white">Fresh & Healthy.</p>',
  //       text: `<p class="m-0">Wholesome Organic Food</p>`,
  //       img: computed(() => {
  //         // const tablet = this.isMobile();
  //         // const mobile = this.isSmallMobile();
  //         // const folder = mobile ? 'Mobile' : tablet ? 'Tablet' : 'Desktop';
  //         // return `/assets/images/shop-slider/${folder}/1.png?v=${version}`
  //         return `/assets/images/landing/home/carousel/4.webp?v=${version}`
  //       })
  //     }
  //   ]);

  //   setTimeout(() => {
  //     this.#setUpDefaultSlider();
  //   });
  // }

  //#endregion
}
